// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as GroupOfUsersComponent} from './GroupOfUsers.svg';

import Icon, { TIconProps } from '../Icon';

export const IconGroupOfUsers = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <GroupOfUsersComponent/>
  </Icon>
));
